import React from "react";
import axios from "axios";
import { baseURL } from "../constants/pathnames";

function toEnNumber(inputNumber) {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];

  var str = inputNumber.toString();
  if (str === "") return "";
  for (var i = 0; i < 10; i++) {
    str = str
      .replace(persianNumbers[i], i.toString())
      .replace(arabicNumbers[i], i.toString());
  }
  return str;

  //   if (inputNumber == undefined || inputNumber == null || inputNumber == "")
  //     return "";
  //   var str = inputNumber.toString();
  //   // if (str == "") return "";
  //   str = str.replace(/۰/g, "0");
  //   str = str.replace(/۱/g, "1");
  //   str = str.replace(/۲/g, "2");
  //   str = str.replace(/۳/g, "3");
  //   str = str.replace(/۴/g, "4");
  //   str = str.replace(/۵/g, "5");
  //   str = str.replace(/۶/g, "6");
  //   str = str.replace(/۷/g, "7");
  //   str = str.replace(/۸/g, "8");
  //   str = str.replace(/۹/g, "9");

  //   str = str.replace(/٤/g, "4");
  //   str = str.replace(/٥/g, "5");
  //   str = str.replace(/٦/g, "6");
  //   return str;
}

export const goTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

export const addCommas = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export const removeNonNumeric = (num) =>
  toEnNumber(num)
    .toString()
    .replace(/[^0-9]/g, "");

export const stringWithoutCommas = (stringWithCommas) => {
  return stringWithCommas.replace(/,/g, "");
};

export const renderer = ({ hours, minutes, seconds }) => {
  return (
    <span>
      {hours}:{minutes}:{seconds}
    </span>
  );
};

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const mobileChecker = (number) => {
  const regex1 = /^09\d{9}$/;
  const regex2 = /^98\d{9}$/;
  const phone = toEnNumber(number);
  return regex1.test(phone) || regex2.test(phone);
};

export const regularPhoneNumber = (number, substring = 1) => {
  const n = 98 + number.toString().substring(substring);
  if (number) return toEnNumber(n);
};
export const moblieNumber = (number, substring = 0) => {
  if (number) return 0 + number.toString().substring(substring);
};

export const numberChecker = (number) => {
  const regex = /^\d+$/;
  return regex.test(number);
};

/* eslint-disable */
export const validateEmail = ($email) => {
  var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  // var regex = /^([\w-]+@([\w-])+[\w-]{2,4})?$/;
  return regex.test($email);
};

export function isEven(n) {
  return n % 2 == 0;
}

export function isOdd(n) {
  return Math.abs(n % 2) == 1;
}

// export const [proviceList, setProviceList] = useState();
export const provinceList = () => {
  const proviceList = [];
  
  axios
    .get(`${baseURL}auth/provinces/`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {});

  // return proviceList;
};

export const rialToToman = (amount) => {
  let number = Number(amount);
  if (number === 0) return amount;
  else {
    let toman_part = number > 9 ? Math.floor(number / 10) : number;
    return toman_part;
  }
};

export const TomanToRial = (amount) => {
 
  let newAmount = stringWithoutCommas(amount) + "0";
  return newAmount;
};


export function objectToQueryString(data) {
  const params = new URLSearchParams();

  for (const key in data) {
    if (Array.isArray(data[key])) {
      let arrayData = data[key];
      if (Array.isArray(arrayData[0])) {
        arrayData = arrayData[0];
      }
      for (const value of arrayData) {
        params.append(key, value);
      }
    } else {
      if(typeof data[key] === 'boolean' || data[key])
      params.set(key, data[key]);
    }
  }

  return params.toString();
}